import React from "react";
import { SelectOption } from "global";
import { FieldValues, Path, Control } from "react-hook-form";
import { LENDER_WATERFALL_FACT_NAMES_STRING } from "@trnsact/types-lender-waterfall";
import { AutocompleteField, ChipsInputField } from "components/form";
import { autocompletePropsByType } from "../constants";

interface Props<FormValues extends FieldValues = FieldValues> {
  name: Path<FormValues>;
  control: Control<FormValues>;
  type: LENDER_WATERFALL_FACT_NAMES_STRING;
}

export const StringFieldsByRule = <FormValues extends FieldValues = FieldValues>({
  control,
  name,
  type,
}: Props<FormValues>) => (
  <>
    {autocompletePropsByType?.[type] ? (
      <AutocompleteField<SelectOption, true, FormValues>
        multiple
        size="small"
        control={control}
        name={`${name}.string.value` as Path<FormValues>}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        {...autocompletePropsByType[type]!}
      />
    ) : (
      <ChipsInputField name={name} control={control} />
    )}
  </>
);
